import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import useReorderCategories from 'modules/categories/hooks/use-reorder-categories';
import {CategoryProps, translatedCategoryProps} from 'modules/categories/types';
import useCompaniesSelectData from 'modules/companies/hooks/use-companies-select-data';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import Creation from 'shared/layout/creation';
import {Operators} from 'shared/migration-components/filter-list/types';
import useFormInputs from 'shared/migration-components/form/util';
import useProjection from 'shared/migration-hooks/use-projection';

const ReorderCategory: React.FC = () => {
  const projection = useProjection('categories', [
    'id',
    'name',
    'active',
    'company.name',
    'company.city.name',
  ]);
  const {getSelect} = useFormInputs<CategoryProps>();
  const {data, isLoading} = useCompaniesSelectData();
  const {companyId} = useAccessControls();

  const navigate = useNavigate();

  const handleViewOrder = (data: any) => {
    projection.filter.onChange({
      'company.name': {operator: Operators.Equals, value: data.companyId},
    });
    projection.orderBy?.onChange({field: data.field, order: 1});
    navigate(-1);

    return data;
  };

  return (
    <Creation<CategoryProps>
      titleBar={{title: 'Ordenação das categorias no aplicativo'}}
      defaultValues={{companyId}}
      {...{handleSubmit: handleViewOrder}}
      inputs={[
        getSelect({
          name: 'companyId',
          data,
          isLoading,
          hidden: () => !!companyId,
        }),
        getSelect({
          name: 'field' as any,
          label: 'Ordenar por',
          data: [
            {label: 'Nome', value: 'name'},
            {label: 'Data de cadastro', value: 'createdAt'},
            {label: 'Customizado', value: 'orderIndex'},
          ],
        }),
      ]}
      onSubmit={useReorderCategories}
      extraButtons={(data) => [
        {title: 'Mostrar ordenação', onClick: () => handleViewOrder(data)},
      ]}
      translationKey={translatedCategoryProps}
    />
  );
};

export default ReorderCategory;
